import { z } from 'zod'

export const ChannelMemberZod = z.object({
  teamId: z.string(),
  teamNumber: z.number().nullish(),
  regionId: z.string(),
  eveningId: z.number(),
})

export type ChannelMember = z.infer<typeof ChannelMemberZod>
